import { Stack } from "@mui/material";
import { useMemo } from "react";

import { DatetimeHelper } from "@/common/helpers/datetime";

import Datetime from "../Datetime/Datetime";
import BooleanValue from "../Form/Display/BooleanValue";
import FieldValue from "../Form/Display/FieldValue";
import { GenericCalendarEntry } from "./Calendar";

interface Props<TEntry extends GenericCalendarEntry> {
  entry: TEntry;
}

export function CalendarEntryDetails<TEntry extends GenericCalendarEntry>({
  entry,
}: Props<TEntry>) {
  const durationHumanized = useMemo(
    () => DatetimeHelper.humanizeDateRangeDuration(entry.start, entry.end),
    [entry],
  );

  return (
    <Stack gap={0}>
      <FieldValue label='Title'>{entry.title}</FieldValue>

      <FieldValue label='Start'>
        <Datetime datetime={entry.start} direction='column' withDurationFromNow />
      </FieldValue>

      <FieldValue label='End'>
        <Datetime datetime={entry.end} direction='column' withDurationFromNow />
      </FieldValue>

      <FieldValue label='Duration'>{durationHumanized}</FieldValue>

      <FieldValue label='All day'>
        <BooleanValue value={entry.isAllDay} />
      </FieldValue>
    </Stack>
  );
}
